(() => {
  'use strict';
  const fallback = document.currentScript.dataset.dialogLabel;
  const dialogSelector = '.fls-popup[role="dialog"], .fls-popup[role="alertdialog"]';
  const formSelector = '.fls-popup-form[role="button"]';
  const selector = dialogSelector + ', .al-chat-toggle, ' + formSelector;
  const watchedSelector = selector + ', flashy-popup';
  const observedRoots = new WeakSet();
  function nameDialog(dialog) {
    const root = dialog.getRootNode();
    const labelIds = (dialog.getAttribute('aria-labelledby') || '').trim();
    if (labelIds && labelIds.split(/\s+/).some(id => {
      const label = root.getElementById(id);
      return label && label.textContent.trim();
    })) return;
    if (labelIds) dialog.removeAttribute('aria-labelledby');
    if ((dialog.getAttribute('aria-label') || '').trim()) return;
    const heading = dialog.querySelector('h1, h2, h3, [role="heading"]');
    const name = heading && heading.textContent.trim() || fallback;
    if (name) dialog.setAttribute('aria-label', name);
  }
  function nameElement(element) {
    if (element.matches('flashy-popup')) {
      connectPopup(element);
      return;
    }
    if (element.matches(formSelector)) element.removeAttribute('role');
    if (element.matches(dialogSelector)) nameDialog(element);
    if (element.matches('.al-chat-toggle') && element.textContent.trim()) {
      if (element.hasAttribute('aria-label')) element.removeAttribute('aria-label');
    }
  }
  function inspect(node) {
    if (node.nodeType !== 1 && node.nodeType !== 11) return;
    if (node.nodeType === 1) {
      const parent = node.closest(watchedSelector);
      if (parent) nameElement(parent);
    }
    node.querySelectorAll(watchedSelector).forEach(nameElement);
  }
  function connectPopup(host) {
    const connect = () => {
      if (host.isConnected && host.shadowRoot) observeRoot(host.shadowRoot);
    };
    connect();
    if (!host.shadowRoot && window.customElements) {
      window.customElements.whenDefined('flashy-popup').then(connect);
    }
  }
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') {
        if (record.target.matches(selector)) nameElement(record.target);
      } else {
        const parent = record.target.nodeType === 1 && record.target.closest(selector);
        if (parent) nameElement(parent);
        record.addedNodes.forEach(inspect);
      }
    }
  });
  function observeRoot(root) {
    if (observedRoots.has(root)) return;
    observedRoots.add(root);
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role', 'aria-label', 'aria-labelledby']
    });
    inspect(root);
  }
  observeRoot(document.body);
})();

